import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const JobStreamUiContext = createContext(null);

/**
 * Broadcasts live job stream fields (from a single hidden SSE) to optional "view-only" consumers.
 */
export function JobStreamUiProvider({ children }) {
  const [uiByJobId, setUiByJobId] = useState({});

  const publishJobStreamUi = useCallback((jobId, patch) => {
    if (jobId == null || jobId === '') return;
    const key = String(jobId);
    setUiByJobId((prev) => ({
      ...prev,
      [key]: { ...(prev[key] || {}), ...patch },
    }));
  }, []);

  const value = useMemo(
    () => ({ publishJobStreamUi, uiByJobId }),
    [publishJobStreamUi, uiByJobId]
  );

  return <JobStreamUiContext.Provider value={value}>{children}</JobStreamUiContext.Provider>;
}

export function useJobStreamUi() {
  return useContext(JobStreamUiContext);
}
